/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plane_Full_Toad_AscendInputs */

const fr_plane_full_toad_ascend = /** @type {(inputs: Plane_Full_Toad_AscendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone`)
};

/**

* @param {Plane_Full_Toad_AscendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plane_full_toad_ascend = /** @type {((inputs?: Plane_Full_Toad_AscendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plane_Full_Toad_AscendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plane_full_toad_ascend(inputs)
});